"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _enum = require("./enum");
var companyappApi = _interopRequireWildcard(require("@/api/companyappApi"));
var _validate = require("@/utils/validate");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _default(_ref) {
  var handleSearch = _ref.handleSearch;
  var FILTER_ITEMS = [{
    type: 'select',
    label: '页面类型：',
    prop: 'pageType',
    attrs: {
      placeholder: '请选择',
      clearable: true
    },
    options: _enum.pageTypeEnum,
    events: {
      change: function change(val) {
        return handleSearch({
          pageType: val
        });
      }
    }
  }, {
    type: 'select',
    label: '关联小程序：',
    prop: 'appId',
    attrs: {
      placeholder: '请选择',
      clearable: true
    },
    options: [],
    events: {
      change: function change(val) {
        return handleSearch({
          appId: val
        });
      }
    },
    async: true,
    load: function load(item) {
      var res = companyappApi.companyappAutoListApi();
      item.options = (res || []).map(function (v) {
        return {
          label: v.appName,
          value: v.id
        };
      });
    }
  }, {
    type: 'select',
    label: '状态：',
    prop: 'status',
    attrs: {
      placeholder: '请选择',
      clearable: true
    },
    options: [{
      label: '禁用',
      value: 0
    }, {
      label: '启用',
      value: 1
    }],
    events: {
      change: function change(val) {
        return handleSearch({
          status: val
        });
      }
    }
  }];
  return {
    FILTER_ITEMS: FILTER_ITEMS
  };
}